/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */
/* ==================================================================
 * CARRITO ALMADA (17 sep 2026)
 * 1. Barra de envío gratis que se va llenando
 * 2. Cambiar talla desde el carrito
 * 3. «Completa tu look» dentro del carrito
 * El carrito se vuelve a dibujar entero en cada cambio (theme.js → _rerenderCart),
 * así que todo se engancha vigilando el DOM y no con listeners sobre los nodos.
 * ================================================================== */
(function () {
  'use strict';

  var isCartPage = window.theme && window.theme.pageType === 'cart';

  function formatMoney(cents) {
    if (window.Currency && window.theme && window.theme.moneyFormat) {
      var tmp = document.createElement('div');
      tmp.innerHTML = Currency.formatMoney(cents, window.theme.moneyFormat);
      return tmp.textContent;
    }
    return '$' + (cents / 100).toLocaleString('es-CO', { minimumFractionDigits: 2 });
  }

  function refreshCart(addedQuantity) {
    if (addedQuantity && !isCartPage) {
      document.dispatchEvent(new CustomEvent('product:added', { bubbles: true, detail: { quantity: addedQuantity } }));
    } else {
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
    }
  }

  function postJSON(url, body) {
    return fetch(url, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(body)
    }).then(function (res) {
      return res.json().then(function (data) {
        if (!res.ok) throw new Error(data.description || data.message || 'Error del carrito');
        return data;
      });
    });
  }

  /* ---------------- 1. Barra de envío gratis ---------------- */
  var lastPct = null;
  try { lastPct = parseFloat(sessionStorage.getItem('almadaFreeShipPct')); } catch (e) {}
  if (isNaN(lastPct)) lastPct = null;

  function animateBar(bar, from) {
    var fill = bar.querySelector('.FreeShipBar__Fill');
    if (!fill) return;
    var to = parseFloat(bar.getAttribute('data-free-ship-pct')) || 0;
    fill.classList.add('is-instant');
    fill.style.width = (from == null ? 0 : from) + '%';
    void fill.offsetWidth; // aplica el punto de partida antes de animar
    fill.classList.remove('is-instant');
    setTimeout(function () { fill.style.width = to + '%'; }, 30);
    lastPct = to;
    try { sessionStorage.setItem('almadaFreeShipPct', to); } catch (e) {}
  }

  /* ---------------- 2. Cambiar talla ---------------- */
  document.addEventListener('change', function (event) {
    var select = event.target.closest && event.target.closest('[data-cart-size-select]');
    if (!select) return;

    var lineKey = select.getAttribute('data-line-key');
    var quantity = parseInt(select.getAttribute('data-quantity'), 10) || 1;
    var newVariantId = parseInt(select.value, 10);
    var item = select.closest('.CartItem');

    select.disabled = true;
    if (item) item.classList.add('is-updating');

    // Primero se agrega la talla nueva y solo si funcionó se quita la anterior:
    // así nunca se pierde el artículo si la talla nueva no tiene stock.
    postJSON('/cart/add.js', { items: [{ id: newVariantId, quantity: quantity }] })
      .then(function () { return postJSON('/cart/change.js', { id: lineKey, quantity: 0 }); })
      .then(function () { refreshCart(); })
      .catch(function (error) {
        if (item) item.classList.remove('is-updating');
        select.disabled = false;
        select.value = select.querySelector('option[selected]') ? select.querySelector('option[selected]').value : select.value;
        var msg = document.createElement('span');
        msg.className = 'CartItem__SizeError';
        msg.textContent = 'Esa talla no está disponible en esa cantidad';
        select.parentNode.appendChild(msg);
        setTimeout(function () { msg.remove(); }, 4000);
        console.warn('[ALMADA carrito] cambio de talla:', error);
      });
  });

  /* ---------------- 3. Completa tu look ---------------- */
  var complementaryCache = {};
  var productCache = {};

  function getComplementary(productId) {
    if (!complementaryCache[productId]) {
      complementaryCache[productId] = fetch('/recommendations/products.json?product_id=' + productId + '&intent=complementary&limit=10', { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.json() : { products: [] }; })
        .then(function (d) { return d.products || []; })
        .catch(function () { return []; });
    }
    return complementaryCache[productId];
  }

  function getProduct(handle) {
    if (!productCache[handle]) {
      productCache[handle] = fetch('/products/' + handle + '.js', { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.json() : null; })
        .catch(function () { return null; });
    }
    return productCache[handle];
  }

  function kindOf(handle) {
    if (/^top/.test(handle)) return 'top';
    if (/^(pantal|short|falda|jean)/.test(handle)) return 'bottom';
    return 'other';
  }

  function sizeIndex(product) {
    var idx = -1;
    (product.options || []).forEach(function (o, i) {
      var name = (typeof o === 'string' ? o : o.name || '').toLowerCase();
      if (name === 'talla' || name === 'size' || name === 'tamaño') idx = i;
    });
    return idx;
  }

  function buildCard(product) {
    var available = product.variants.filter(function (v) { return v.available; });
    if (!available.length) return null;

    var si = sizeIndex(product);
    var base = available[0];
    var sameColor = product.variants.filter(function (v) {
      return v.options.every(function (val, i) { return i === si || val === base.options[i]; });
    });

    var card = document.createElement('div');
    card.className = 'CartLook__Card';

    var img = product.featured_image || (product.images && product.images[0]) || '';
    if (img && typeof img === 'object') img = img.src || img.url || '';
    if (img) img = img + (img.indexOf('?') > -1 ? '&' : '?') + 'width=300';

    card.innerHTML =
      '<a class="CartLook__ImageLink" href="/products/' + product.handle + '">' +
        (img ? '<img class="CartLook__Image" loading="lazy" alt="" src="' + img + '">' : '') +
      '</a>' +
      '<a class="CartLook__Title Heading" href="/products/' + product.handle + '"></a>' +
      '<p class="CartLook__Price Heading Text--subdued">' + formatMoney(base.price) + '</p>' +
      '<div class="CartLook__Sizes"></div>';
    card.querySelector('.CartLook__Title').textContent = product.title;

    var sizes = card.querySelector('.CartLook__Sizes');
    var variantsToShow = si > -1 ? sameColor : [base];
    variantsToShow.forEach(function (v) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'CartLook__Size';
      b.textContent = si > -1 ? v.options[si] : 'Agregar';
      b.disabled = !v.available;
      b.setAttribute('aria-label', 'Agregar ' + product.title + (si > -1 ? ' talla ' + v.options[si] : ''));
      b.addEventListener('click', function () {
        card.classList.add('is-adding');
        b.textContent = '…';
        postJSON('/cart/add.js', { items: [{ id: v.id, quantity: 1 }] })
          .then(function () { refreshCart(1); })
          .catch(function (err) {
            card.classList.remove('is-adding');
            b.textContent = si > -1 ? v.options[si] : 'Agregar';
            console.warn('[ALMADA carrito] agregar desde Completa tu look:', err);
          });
      });
      sizes.appendChild(b);
    });
    return card;
  }

  function fillLook(container) {
    var items;
    try { items = JSON.parse(container.getAttribute('data-cart-items') || '[]'); } catch (e) { items = []; }
    if (!items.length) return;

    var track = container.querySelector('[data-cart-look-track]');
    var inCart = {};
    var kinds = { top: false, bottom: false };
    items.forEach(function (it) {
      inCart[it.product_id] = true;
      var k = kindOf(it.handle);
      if (k !== 'other') kinds[k] = true;
    });

    Promise.all(items.map(function (it) { return getComplementary(it.product_id); })).then(function (lists) {
      var alreadyCompleted = false;
      var seen = {};
      var pending = [];

      lists.forEach(function (list, i) {
        list.forEach(function (p) {
          if (p.id === items[i].product_id) return;
          if (inCart[p.id]) { alreadyCompleted = true; return; }
          if (!seen[p.id]) { seen[p.id] = true; pending.push(p); }
        });
      });

      // Regla de Pilar: si ya agregó algo de «Completa tu look» (o no hay complementarios),
      // se muestran las favoritas fijas; si no, los complementarios que le faltan.
      if (!alreadyCompleted && pending.length) return pending;

      var tops = (container.getAttribute('data-tops') || '').split(',').filter(Boolean);
      var bottoms = (container.getAttribute('data-bottoms') || '').split(',').filter(Boolean);
      var handles;
      if (kinds.top && !kinds.bottom) handles = bottoms;
      else if (kinds.bottom && !kinds.top) handles = tops;
      else {
        handles = [];
        for (var i = 0; i < Math.max(tops.length, bottoms.length); i++) {
          if (bottoms[i]) handles.push(bottoms[i]);
          if (tops[i]) handles.push(tops[i]);
        }
      }
      return Promise.all(handles.map(getProduct)).then(function (products) {
        return products.filter(function (p) { return p && !inCart[p.id]; });
      });
    }).then(function (products) {
      if (!container.isConnected) return; // el carrito ya se volvió a dibujar
      track.innerHTML = '';
      var count = 0;
      (products || []).some(function (p) {
        var card = buildCard(p);
        if (card) { track.appendChild(card); count++; }
        return count >= 6;
      });
      if (count) container.hidden = false;
    });
  }

  /* ---------------- Enganche con el DOM ---------------- */
  function scan(root) {
    if (!root || root.nodeType !== 1) return;
    var bars = root.matches('.FreeShipBar') ? [root] : root.querySelectorAll('.FreeShipBar:not([data-animated])');
    Array.prototype.forEach.call(bars, function (bar) {
      if (bar.hasAttribute('data-animated')) return;
      bar.setAttribute('data-animated', '');
      animateBar(bar, lastPct);
    });
    var looks = root.matches('[data-cart-look]') ? [root] : root.querySelectorAll('[data-cart-look]:not([data-filled])');
    Array.prototype.forEach.call(looks, function (look) {
      if (look.hasAttribute('data-filled')) return;
      look.setAttribute('data-filled', '');
      fillLook(look);
    });
  }

  function init() {
    scan(document.body);

    new MutationObserver(function (mutations) {
      mutations.forEach(function (m) {
        Array.prototype.forEach.call(m.addedNodes, scan);
      });
    }).observe(document.body, { childList: true, subtree: true });

    var drawer = document.getElementById('sidebar-cart');
    if (drawer) {
      new MutationObserver(function () {
        if (drawer.getAttribute('aria-hidden') === 'false') {
          var bar = drawer.querySelector('.FreeShipBar');
          if (bar) setTimeout(function () { animateBar(bar, 0); }, 250);
        }
      }).observe(drawer, { attributes: true, attributeFilter: ['aria-hidden'] });
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
